// extracted by mini-css-extract-plugin
module.exports = {"perkBox":"perk-box_perkBox__VY_tH","perk":"perk-box_perk__WYNoG","perkLogo":"perk-box_perkLogo__AbD_t","perkName":"perk-box_perkName__MohTn"};